import React, { useRef } from "react";
import MarkdownWithLaTeX from "./markDownWithLatex";
import Tippy from "@tippyjs/react";
import Copy from "./copy";

const Explanation = ({ pollMode, useExplanation, explanation, grading, isDarkTheme }) => {
    const explanationRef = useRef(null);

    return (
        <>
            {
                useExplanation && explanation && (grading || pollMode) && (
                    <div className="explanation-wrapper">
                        <div className="explanation-wrapper-text">
                            Explanation:                        
                            <Copy text={explanation} explanationRef={explanationRef}/>
                        </div>
                        <div ref={explanationRef} className="true-false-top">
                            <MarkdownWithLaTeX isDarkTheme={isDarkTheme} content={explanation}/>
                        </div>
                    </div>
                )
            }
        </>
    );
}

export default Explanation;